// src/firebase.js
// تم التعديل لاستخدام Firebase المُحمّل عبر CDN في index.html وحل مشكلة تزامن الـ Service Worker

/**
 * الحصول على كائن Firebase من النافذة العامة
 */
const getFirebase = () => {
  if (typeof window !== 'undefined' && window.firebase) {
    return window.firebase;
  }
  return null;
};

/**
 * طلب الإذن للإشعارات والحصول على التوكن بشكل متزامن وآمن
 */
export const requestPermission = async () => {
  try {
    console.log('🔔 طلب الإذن للإشعارات...');

    const firebase = getFirebase();
    if (!firebase) {
      console.error('❌ Firebase لم يتم تحميله. تأكد من وجود السكربتات في index.html');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('✅ تم منح الإذن للإشعارات');

      // الانتظار حتى يتأكد المتصفح من جاهزية وتنشيط الـ Service Worker
      // هذا السطر يمنع ظهور خطأ (Subscription failed - no active Service Worker)
      const registration = await navigator.serviceWorker.ready;
      console.log('✅ تم التحقق من جاهزية الـ Service Worker بالتطابق التام');

      const messaging = firebase.messaging();
      const VAPID_KEY = 'BCKSJEG_xdScrD5yEY4_twMaf5NaDWQSuSnN3zJzHcWF5dQ6vH7bD40AYxJMhNOM4D6ySReYPNA2_hR6YZaPY8w';

      // تمرير الـ registration النشط صراحةً للـ SDK المأخوذ من الـ CDN
      const token = await messaging.getToken({
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration
      });

      console.log('📱 توكن الجهاز الجديد المتزامن:', token);

      localStorage.setItem('fcmToken', token);
      await saveTokenToServer(token);

      return token;
    } else {
      console.log('❌ تم رفض الإذن للإشعارات');
      return null;
    }
  } catch (error) {
    console.error('❌ خطأ في طلب الإذن:', error);
    return null;
  }
};

/**
 * حفظ التوكن في الخادم الخلفي
 */
const saveTokenToServer = async (token) => {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      console.log('⚠️ المستخدم غير مسجل');
      return;
    }

    const user = JSON.parse(userStr);
    if (!user || !user.id) {
      console.log('⚠️ بيانات المستخدم غير مكتملة');
      return;
    }

    const response = await fetch('/api/notifications/register-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        userId: user.id,
        token: token,
        device: 'web'
      })
    });

    if (response.ok) {
      console.log('✅ تم تسجيل التوكن في الخادم');
    } else {
      const data = await response.json();
      console.log('❌ فشل تسجيل التوكن:', data);
    }
  } catch (error) {
    console.error('❌ خطأ في حفظ التوكن:', error);
  }
};

/**
 * الاستماع للإشعارات أثناء تصفح التطبيق
 */
export const listenForMessages = (onMessageCallback) => {
  try {
    const firebase = getFirebase();
    if (!firebase) {
      console.error('❌ Firebase لم يتم تحميله');
      return;
    }

    const messaging = firebase.messaging();

    messaging.onMessage((payload) => {
      console.log('📨 إشعار جديد:', payload);

      const notification = payload.notification || {};
      const data = payload.data || {};

      if (onMessageCallback) {
        onMessageCallback({
          title: notification.title || 'إشعار جديد',
          body: notification.body || '',
          icon: notification.icon || '/logo192.png',
          data: data,
          clickAction: data.clickAction || '/'
        });
      }

      if (Notification.permission === 'granted') {
        const options = {
          body: notification.body || '',
          icon: notification.icon || '/logo192.png',
          data: data,
          requireInteraction: true,
          actions: [
            { action: 'open', title: 'فتح' },
            { action: 'dismiss', title: 'تجاهل' }
          ]
        };

        const notificationObj = new Notification(
          notification.title || 'إشعار جديد',
          options
        );

        notificationObj.onclick = () => {
          window.focus();
          const clickAction = data.clickAction || '/';
          window.location.href = clickAction;
        };
      }
    });
  } catch (error) {
    console.error('❌ خطأ في الاستماع للإشعارات:', error);
  }
};

/**
 * دالة للتحقق من جاهزية Firebase
 */
export const initFirebase = () => {
  const firebase = getFirebase();
  if (firebase) {
    console.log('✅ Firebase جاهز للاستخدام');
    return true;
  } else {
    console.warn('⚠️ Firebase غير جاهز بعد');
    return false;
  }
};

// تصدير افتراضي
export default { requestPermission, listenForMessages, initFirebase };